import { useDispatch } from "react-redux";
import { openPopup} from "../../../store/popupSlice"
import { Helmet } from "react-helmet-async";
import Breadcrumb from "../../../component/Breadcrumb";

const breadcrumbData = {
  newClass:"",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Zipcar Clone App",
      slug:""
    },
  ]
}

export default function ZipBanner() {
  const dispatch=useDispatch();
  return (
    <>
      <Helmet>
        <link rel="preload" href="/assets/home/zip-banner.webp" as="image" type="image/webp"/>
      </Helmet>
      <section className="zip-banner header-gap">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6 col-md-6">
              <div className="zip-banner-head">
                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <h1 className="heading"> <span className="gradiant-color">Zipcar Clone App</span> <small>Build Your Car-Sharing Platform</small></h1>
                <p>The future of urban mobility lies in smart, self-service transportation, and Mobility Infotech helps you get there faster. Our Zipcar-like white-label solution empowers you to offer on-demand car rentals with seamless booking, remote access, and automated returns. From startups to enterprise fleets, our scalable platform puts your car-sharing business in the driver’s seat.</p>
                <button onClick={() => dispatch(openPopup())}  className="default-btn">Get FREE DEMO</button>
              </div>
            </div>
            <div className="col-lg-5 col-md-6">
              <img src="/assets/home/zip-banner.webp" alt="zipcar" className="img-responsive zip-banner-img" />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
